import { Website } from "../website-builder/wedding";


const defaultWebsite = new Website();

// Set any necessary properties of website here
let sixMonthsFromToday = new Date();
sixMonthsFromToday.setMonth(sixMonthsFromToday.getMonth() + 6);
let threeMonthsFromToday = new Date();
threeMonthsFromToday.setMonth(threeMonthsFromToday.getMonth() + 3);

let sixMonthsFromTodayPlusOneDay = new Date(sixMonthsFromToday);
sixMonthsFromTodayPlusOneDay.setDate(sixMonthsFromTodayPlusOneDay.getDate() + 1);


defaultWebsite.sectionOrder = [
  'story',
  'schedule',
  'rsvp',
  'weddingParty',
  'travel',
  'registry',
  'questions'
]
defaultWebsite.defaultMode = true;
defaultWebsite.layout = 'full',
  defaultWebsite.template = 'celine',
  defaultWebsite.colors = {
    light: '#F5EFE5',
    dark: '#04341B',
    lightAccent: '#CB6342',
    darkAccent: '#5075AB',
    accent: '#1D1D1D'
  };

defaultWebsite.colorsMinimalTemplateDefault = {
  light: '#F5EFE5',
  dark: '#04341B',

};

defaultWebsite.fonts = {
  heading: 'Inter Variable',
  paragraph: 'Inter Variable',
  misc: 'Inter Variable'
};
defaultWebsite.rsvp = {
  sectionNameTextTranslation: '',
  isEnabled: true,
  sectionName: 'RSVP',
}
defaultWebsite.style = 'minimal';
defaultWebsite.weddingEvents = [
  {
    address: '49-560 Kamehameha Hwy, Kaneohe, HI',
    startDate: sixMonthsFromToday,
    startDateUtc: null,
    description: 'We\'re exchanging vows surrounded by the breathtaking views of Paliku Gardens. Join us as we begin this next chapter together.',
    endTime: '1:00 PM',
    eventName: 'Wedding Day',
    startTime: '10:00 PM',
    venue: 'Paliku Gardens',
    attire: 'Semi-Formal',
    collectRsvpsOnWebsite: true,
    attendanceQuestion: {
      id: "wedenv_rsvp" + new Date().getTime().toString() + 1,
      question: 'Will you be attending our wedding?',
      questionType: 'multi select',
      options: ['Yes', 'No'],
      optionsTranslation: [],
      optional: false,
      questionTranslation: ''

    }
    ,    rsvpQuestions: [
      {
        question: 'Do you have any dietary restrictions?',
        questionType: 'text',
        options: [],
        optionsTranslation: [],
        questionTranslation: '',
        optional: false,
        id: 'dietary_restrictions_'
      },

     
    ],
    createdDate: null,
    modifiedDate: null,
    id: "wedenv-" + new Date().getTime().toString() + 3,
    endDate: sixMonthsFromTodayPlusOneDay,
    endDateUtc: null,
    isPrivate: false,
    addressTranslation: '',
    attireTranslation: '',
    descriptionTranslation: '',
    eventNameTranslation: '',
    venueTranslation: ''
  },


];

// ,    rsvpQuestions: [

//   {
//     question: 'Leave a note for the couple',
//     questionType: 'text',
//     options: [],
//     optionsTranslation: [],
//     questionTranslation: '',
//     optional: true,
//     id: new Date().getTime().toString() + 3

//   },
// ],
defaultWebsite.welcome = {
  heroImageUrl: '/assets/public/images/website-templates/celine.jpg?q=45',
  sectionName: 'Welcome',
  eventDisplayName: 'Celine & Étienne',
  greetings: 'After years of love, laughter, and exploring the world together, we\'re excited to begin our next adventure. We can\'t wait to celebrate with the people who mean the most.',
  eventDate: sixMonthsFromToday,
  eventDateUtc: null,
  eventEndDate: null,
  eventEndDateUtc: null,
  eventLocation: 'Hawaii',
  isEnabled: true,
  heroImageUrlEnabled: true,
  eventDisplayNameTranslation: '',
  greetingsTranslation: '',
  // sectionNameTranslation: '',
  updated: false,
  rsvpDeadline: threeMonthsFromToday,
  rsvpShortNote: 'RSVP Deadline',
  rsvpShortNoteTranslation: '',
  rsvpDeadlineDateUtc: null,

};
defaultWebsite.story = {
  sectionName: 'Story',
  sectionNameTranslation: '',
  storyText: 'From there, it\'s been a whirlwind. We\'ve traveled to ten countries, tried way too much food, and learned that the best adventures always happen when you\'re with your favorite person. Whether it\'s getting lost in a new city or just hanging out on the couch, we\'ve made a lifetime of memories together. Now, we\'re ready for our biggest adventure yet. We\'re so excited to share this moment with you and can\'t wait to celebrate surrounded by the people we love most.',
  isEnabled: true,
  imageUrl: '/assets/public/images/website-templates/celine-story-grid-1.jpg?q=45',
  imageUrl2: '/assets/public/images/website-templates/celine-story-grid-2.jpg?q=45',
  imageUrl3: '/assets/public/images/website-templates/celine-story-grid-3.jpg?q=45',
  imageUrl4: '/assets/public/images/website-templates/celine-story-grid-4.jpg?q=45',
  imageUrl5: '/assets/public/images/website-templates/celine-story-grid-5.jpg?q=45',
  imageUrl6: '/assets/public/images/website-templates/celine-story-grid-6.jpg?q=45',
  imageEnabled: true,
  storyTextTranslation: '',
  imageGrid: 'grid1',
  updated: false,
  storyHighlight: 'We first met in college, and, like any good story, it wasn\'t love at first sight—at least, not right away. After a few run-ins and some missed chances, we finally reconnected, and this time, it just clicked.',
  storyHighlightTranslation: '',

};
defaultWebsite.announcement = {
  headline: 'Weather Reminder',
  sectionName: 'Announcement',
  message: 'The forecast for our wedding day shows a chance of light rain and cooler temperatures. Please bring a jacket or umbrella to stay comfortable, especially during outdoor moments.',
  isEnabled: false,
  headlineTranslation: '',
  messageTranslation: '',


};
defaultWebsite.schedule = {
  sectionNameTranslation: '',
  updated: false,
  scheduleItems: [
    {
      eventName: 'Ceremony',
      startDate: sixMonthsFromToday,
      startDateUtc: null,
      endDateUtc: null,
      startTime: '1:00 PM',
      endTime: '2:00 PM',
      endDate: sixMonthsFromToday,
  
      venue: 'Paliku Gardens',
      address: '49-560 Kamehameha Hwy, Kaneohe, HI',
      attire: 'Semi-Formal Attire',
      description: 'We\'re exchanging vows surrounded by the breathtaking views of Paliku Gardens. Join us as we begin this next chapter together.',
addressTranslation: '',
attireTranslation: '',
descriptionTranslation: '',
eventNameTranslation: '',
venueTranslation: ''
    },
    {
      eventName: 'Reception',
      startDate: sixMonthsFromToday,
      startTime: '5:00 PM',
      startDateUtc: null,
      endDateUtc: null,
      endTime: '11:00 PM',
      endDate: sixMonthsFromToday,
      venue: 'Kualoa Ranch',
      address: '49-560 Kamehameha Hwy, Kaneohe, HI',
      attire: 'Semi-Formal Attire',
      description: 'Celebrate with us under the stars at Kualoa Ranch. Enjoy great food, dancing, and unforgettable memories. Let\'s make this a night full of laughter, love, and moments to cherish.',
      addressTranslation: '',
attireTranslation: '',
descriptionTranslation: '',
eventNameTranslation: '',
venueTranslation: ''
    },
    {
      eventName: 'Luncheon',
      startDate: sixMonthsFromTodayPlusOneDay,
      startTime: '10:00 AM',
      endTime: '',
      endDate: null,
      startDateUtc: null,
      endDateUtc: null,
      venue: 'Haleiwa Joe\'s',
      address: '46-336 Haiku Road, Kaneohe, HI',
      attire: '',
      description: 'Join us for lunch at Haleiwa Joe\'s, where we can reminisce about the day before and enjoy a delicious meal together. It\'ll be the perfect way to unwind and share stories after the big celebration.',
      addressTranslation: '',
attireTranslation: '',
descriptionTranslation: '',
eventNameTranslation: '',
venueTranslation: ''
    },
    {
      eventName: 'Farewell Dinner',
      startDate: sixMonthsFromTodayPlusOneDay,
      startTime: '7:00 PM',
      endTime: '',
      endDate: null,
      venue: 'Uncle Bobo\'s',
      address: '51-480 Kamehameha Hwy, Kaaawa, HI',
      attire: '',
      description: 'For those able to join, we\'d love to gather one last time to share a casual dinner before we head off on our honeymoon, and wrap up this unforgettable weekend with great food and even better company.',
      addressTranslation: '',
      attireTranslation: '',
      descriptionTranslation: '',
      eventNameTranslation: '',
      venueTranslation: '',
      startDateUtc: null,
      endDateUtc: null,
    },
  ],
  sectionName: 'Schedule',
  isEnabled: true,
};
defaultWebsite.weddingParty = {
  sectionNameTranslation: '',
  intro: 'Meet the crew that\'s kept us laughing, supported us through every adventure, and somehow survived planning this wedding with us. These are the people who\'ve witnessed the late-night dance-offs, heard all the ridiculous inside jokes, and been there for the best and worst hair days.',
  introTranslation: '',
  partyMembers: [
    {
      firstName: 'Charlotte',
      lastName: 'Lafrenière',
      role: 'Maid of Honor',
      imageUrl: '/assets/public/images/website-templates/wp-11.png?q=45',
      story: 'Charlotte\'s warmth and calm presence have been a constant source of comfort and joy. Her friendship has been a gift, and she\'s played such an important role in our lives.',
      email: 'charlotte.lafreniere@mail.com',
      phone: '(425) 822)',
      roleTranslation: '',
      storyTranslation: ''
    },
    {
      firstName: 'James',
      lastName: 'Elliman',
      role: 'Best Man',
      imageUrl: '/assets/public/images/website-templates/wp-22.png?q=45',
      story: 'James\'s loyalty and steady presence have shaped so many of our best moments. His friendship is something we deeply value, and we\'re lucky to have him by our side.',
      email: 'james.elliman@mail.com',
      phone: '(415) 555-0173',
      roleTranslation: '',
      storyTranslation: ''
    }, {
      firstName: 'Eleanor',
      lastName: 'Van Forde',
      role: 'Bridesmaid',
      imageUrl: '/assets/public/images/website-templates/wp-33.png?q=45',
      story: 'Eleanor\'s sense of humor and generous spirit make her an irreplaceable part of our journey. Her joyful nature brings light to every gathering she\'s part of.',
      email: 'eleanor.vanforde@mail.com',
      phone: '(415) 555-0173',
      roleTranslation: '',
      storyTranslation: ''
    },
    {
      firstName: 'William',
      lastName: 'Hart',
      role: 'Groomsman',
      imageUrl: '/assets/public/images/website-templates/wp-44.png?q=45',
      story: 'William\'s easy-going nature and thoughtful advice have been a guiding light. His friendship is something we both treasure and hold close.',
      email: 'william.hart@mail.com',
      phone: '(415) 555-0173',
      roleTranslation: '',
      storyTranslation: ''
    },
    {
      firstName: 'Isabelle',
      lastName: 'Clarke',
      role: 'Bridesmaid',
      imageUrl: '/assets/public/images/website-templates/wp-66.png?q=45',
      story: 'Isabelle\'s loyalty and joyful energy have been at the heart of our most meaningful moments. She\'s been an anchor of positivity, and we cherish her deeply.',
      email: 'isabelle.clarke@mail.com',
      phone: '(415) 555-0173',
      roleTranslation: '',
      storyTranslation: ''
    },
    {
      firstName: 'Daniel',
      lastName: 'Bloomberg',
      role: 'Groomsman',
      imageUrl: '/assets/public/images/website-templates/wp-55.png?q=45',
      story: 'Daniel\'s wisdom and humor have always been a guiding force. His friendship has meant so much to both of us, and we\'re honored to have him as such a prominent figure in our lives.',
      email: 'daniel.bloomberg@mail.com',
      phone: '(415) 555-0173',
      roleTranslation: '',
      storyTranslation: ''
    },
  
    {
      firstName: 'Sophia',
      lastName: 'Grant',
      role: 'Flower Girl',
      imageUrl: '/assets/public/images/website-templates/wp-77.png?q=45',
      story: 'Sophie\'s playful spirit and bright smile never fail to bring joy. She\'s a ray of sunshine, and we can\'t wait for her to light up this special day.',
      email: 'sophia.grant@mail.com',
      phone: '(415) 555-0173',
      roleTranslation: '',
      storyTranslation: ''
    }, {
      firstName: 'Theo',
      lastName: 'Lawson',
      role: 'Ring Bearer',
      imageUrl: '/assets/public/images/website-templates/wp-88.png?q=45',
      story: 'Theo\'s energy and fun-loving nature are infectious. His excitement adds so much happiness to this celebration, and we can\'t wait to see him in action.',
      email: 'theo.lawson@mail.com',
      phone: '(415) 555-0173',
      roleTranslation: '',
      storyTranslation: ''
    }
  ],
  sectionName: 'Wedding Party',
  isEnabled: true,
};
defaultWebsite.travel = {

  travelInfo: [
    {
      travelLinks: [],
      address: "57-091 Kamehameha Hwy, Kahuku, HI",
      discountCode:"",
      flightNumber:"",
      notes:"Turtle Bay Resort is offering special wedding rates for our guests. Located on the stunning North Shore, it's the perfect blend of luxury and island vibes. Just mention our wedding for a discount when booking.",
      phone:"(808) 293-6000",
      travelType:"hotel",
      url:"https://www.turtlebayresort.com/",
      title: "Turtle Bay Resort",
      titletranslation: "",
      notesTranslation: "",
      
    },
    {
      travelLinks: [],
      address: "55-400 Kamehameha Hwy, Laie, HI",
      discountCode:"",
      flightNumber:"",
      notes:"For a more budget-friendly option, Courtyard Oahu North Shore provides comfort and convenience, just a short drive from Kualoa Ranch. They've reserved a block of rooms at a special rate for our guests.",
      phone:"(808) 293-6000",
      travelType:"hotel",
      url:"https://www.marriott.com/en-us/hotels/hnloa-courtyard-oahu-north-shore/overview",
      title: "Courtyard Oahu North Shore",
      titletranslation: "",
      notesTranslation: "",
    
      
    },
    {
      travelLinks: [],
      address: "45-1044 Kamehameha Hwy, Kaneohe, HI",
      discountCode:"",
      flightNumber:"",
      notes:"For those planning to explore the island, Enterprise Rent-A-Car is offering discounted rates for wedding guests. Book online or call using the code HAWAIICELEBRATION for the offer.",
      phone:"(808) 236-7882",
      travelType:"rental car",
      url:"https://www.enterprise.com/en/car-rental-locations/us/hi.html",
      title: "Enterprise Rent-A-Car",
      titletranslation: "",
      notesTranslation: "",
      
    },
    {
      travelLinks: [],
      address: "",
      discountCode:"ALOHAWEDDING",
      flightNumber:"HA 3",
      notes:"Hawaiian Airlines is offering discounted fares for guests flying in for the wedding. Use the promo code when booking online to receive the discount.",
      travelType:"flight",
      url:"https://www.hawaiianairlines.com.au/",
      title: "Hawaiian Airlines",
      titletranslation: "",
      notesTranslation: "",
      phone: ""
    },
    {
      travelLinks: [],
      address: "680 Iwilei Road, Suite 700, Honolulu, HI",
      discountCode:"",
      flightNumber:"",
      notes:"Roberts Hawaii Shuttle is available for easy transportation between the airport and your hotel. Mention the wedding for a special fare rate.",
      phone:"(808) 523-7750",
      travelType:"shuttle",
      url:"https://www.robertshawaii.com/airport-shuttle/",
      title: "Roberts Hawaii Shuttle",
      titletranslation: "",
      notesTranslation: "",
      
    },
    {
      travelLinks: [],
      address: "57-091 Kamehameha Hwy, Kahuku, HI 96731, USA",
      discountCode:"",
      flightNumber:"",
      notes:"For those with extra time, the Polynesian Cultural Center offers a unique experience of Hawaiian culture. They are offering a 10% discount for our wedding guests.",
      phone:"(808) 293-6000",
      travelType:"travel note",
      url:"https://www.polynesia.com/",
      title: "Polynesian Cultural Center",
      titletranslation: "",
      notesTranslation: "",
      
    }
  ],
  sectionName: 'Travel Guide',
  isEnabled: true,
  sectionNameTranslation: '',
};


defaultWebsite.questions = {
  sectionNameTranslation: '',
  questions: [
    {
      title: 'What\'s the dress code?',
      text: 'The dress code is semi-formal. Feel free to dress in light, breathable fabrics to stay comfortable in the island breeze. Think elegant yet relaxed tropical vibes.',
      textTranslation: '',
      titleTranslation: ''
    },
    {
      title: 'Are children invited?',
      text: 'We love your little ones, but this celebration is adults-only to ensure a peaceful and enjoyable experience for everyone.'
      ,
      textTranslation: '',
      titleTranslation: ''
    },
    {
      title: 'Can I take pictures?',
      text: 'We kindly ask that you refrain from taking photos during the ceremony so that everyone can be fully present. After the ceremony, feel free to snap away and capture all the fun moments!',
      textTranslation: '',
      titleTranslation: ''
    },
    {
      title: 'Is parking available?',
      text: 'Yes, there is ample parking available at the venue. Please follow the signs when you arrive for easy access.',
      textTranslation: '',
      titleTranslation: ''
    },
    {
      title: 'Will there be transportation provided?',
      text: 'Yes! We will have a shuttle service available between the ceremony and reception venues. More details, including pickup times and locations, will be provided closer to the date.',
      textTranslation: '',
      titleTranslation: ''
    },
    {
      title: 'What kind of footwear should I wear?',
      text: 'Since the ceremony and reception will take place in outdoor garden and ranch settings, we recommend comfortable shoes or wedges. Heels might be tricky on grass and uneven terrain, so opt for footwear that lets you move easily and enjoy the celebration.',
      textTranslation: '',
      titleTranslation: ''
    }
  ],
  sectionName: 'FAQ',
  isEnabled: true,
};
defaultWebsite.registry = {
  registryItems: [
    {
      name: "Anthropologie",
      url: "https://www.anthropologie.com/anthroliving/",
      logo: "",
     },
     {
      name: "Nordstrom",
      url: "https://www.nordstrom.com/",
      logo: "",
     },
     {
      name: "Williams Sonoma",
      url: "https://www.williams-sonoma.com",
      logo: "",
     }
    
  ],
  buttonText: 'Honeymoon Registry',
  buttonTextTranslation: 'Honeymoon Registry',
  isLinkedtoHitchd: true,
  sectionName: 'Registry',
  isEnabled: true,
  sectionNameTranslation: '',

  leadInText: 'If you\'d like to help us kickstart our next adventure, we\'ve put together a few thoughtful ideas to make everyday moments even more special. No pressure at all — your presence is the greatest gift! But if something catches your eye, we\'ll be forever grateful for your kindness.',
  leadInTextTranslation: '',
};

export default defaultWebsite;


// WEBPACK FOOTER //
// ./src/app/website-template-celine/default-data.ts